import Vue from 'vue';
import { MutationTree } from 'vuex';
import {
    CampaignState,
    CurrentCampaignType,
    CurrentAdsetType,
} from './types';

interface MutationsType {
    SET_CURRENT_CAMPAIGN: (state: CampaignState, payload: CurrentCampaignType) => void;
    CLEAR_CURRENT_CAMPAIGN: (state: CampaignState) => void;
    SET_CURRENT_ADSET: (state: CampaignState, payload: CurrentAdsetType) => void;
    CLEAR_CURRENT_ADSET: (state: CampaignState) => void;
}

export const mutations: MutationTree<CampaignState> & MutationsType = {
    SET_CURRENT_CAMPAIGN: (state: CampaignState, payload: CurrentCampaignType) => {
        const curCamp = state.currentCampaign;
        curCamp.id = payload.id;
        curCamp.name = payload.name;
        curCamp.app = payload.app;
    },
    CLEAR_CURRENT_CAMPAIGN: (state: CampaignState) => {
        const curCamp = state.currentCampaign;
        curCamp.id = '';
        curCamp.name = '';
        curCamp.app = null;
    },
    SET_CURRENT_ADSET: (state: CampaignState, payload: CurrentAdsetType) => {
        const curAdset = state.currentAdset;
        curAdset.idList = payload.idList;
        curAdset.name = payload.name;
    },
    CLEAR_CURRENT_ADSET: (state: CampaignState) => {
        const curAdset = state.currentAdset;
        curAdset.idList = [];
        curAdset.name = '';
    }
};
